module.exports = __webpack_public_path__ + "img/path-3.780b9eea.svg";